import React, { FunctionComponent } from 'react';
import Accordion, { AccordionSection } from '@justgiving/accordion';
import styles from './StreamChat.scss';

export type StreamChatProps = {
  title: string | null;
  streamUrl: string | null;
  chatUrl?: string | null;
} | null;

const StreamChat: FunctionComponent<StreamChatProps> = props => {
  if (!props) {
    return null;
  }

  const { chatUrl, title } = props;
  if (!chatUrl || !title) {
    return null;
  }

  return (
    <div className={styles.streamChatWidget}>
      <Accordion>
        <AccordionSection label="view chat">
          <iframe
            title={`${title} chat`}
            src={`${chatUrl}`}
            height="300"
            width="100%"
            frameBorder="0"
            scrolling="no"
            data-qa="feature-image-stream-chat"
          />
        </AccordionSection>
      </Accordion>
    </div>
  );
};

export default StreamChat;
